var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-users","titulo":"TOTAL DE ACESSOS","qtd":_vm.qtd,"loading":_vm.loading,"color":"#A3E0FC"}})
}
var staticRenderFns = []

export { render, staticRenderFns }